// src/utils/mapWildfireIncidentToAlert.js

// Basic heuristic severity based on type, size, and containment
function inferWildfireSeverity(attrs) {
  if (!attrs) return "severe";

  const type = attrs.IncidentTypeCategory; // "WF" or "RX"
  const percent =
    typeof attrs.PercentContained === "number" ? attrs.PercentContained : null;
  const acres =
    attrs.GISAcres ||
    attrs.polyGISAcres ||
    attrs.DailyAcres ||
    attrs.Acres ||
    attrs.FireSize ||
    0;

  // Prescribed fires are generally lower severity
  if (type === "RX") return "moderate";

  // Fully contained wildfire → treat as lower severity
  if (percent !== null && percent >= 100) {
    return "moderate";
  }

  // Large / low containment wildfires
  if (acres >= 10000 || (percent !== null && percent < 25)) {
    return "extreme";
  }

  if (acres >= 1000 || (percent !== null && percent < 60)) {
    return "severe";
  }

  return "moderate";
}

export function mapWildfireIncidentToAlert(feature) {
  const attrs = (feature && feature.attributes) || {};
  const geometry = feature && feature.geometry;

  const typeCode = attrs.IncidentTypeCategory; // "WF" or "RX"
  const isPrescribed = typeCode === "RX";

  const event = isPrescribed ? "Prescribed Fire" : "Wildfire Incident";
  const headline = attrs.IncidentName || event;

  const descriptionParts = [];

  if (attrs.POOCounty) {
    descriptionParts.push("Origin: " + attrs.POOCounty + " County");
  }
  if (attrs.POOState) {
    descriptionParts.push("State: " + attrs.POOState);
  }

  const size =
    attrs.GISAcres ||
    attrs.polyGISAcres ||
    attrs.DailyAcres ||
    attrs.Acres ||
    attrs.FireSize;

  if (size != null) {
    var acresNum = Number(size);
    if (!isNaN(acresNum)) {
      descriptionParts.push(
        "Size: " + acresNum.toLocaleString() + " acres"
      );
    }
  }

  if (typeof attrs.PercentContained === "number") {
    descriptionParts.push("Containment: " + attrs.PercentContained + "%");
  }

  const description = descriptionParts.join(". ");
  const severity = inferWildfireSeverity(attrs);

  // Higher subtype for active WF, lower for RX and fully contained WF
  var eventSubtypeSeverity = 0;
  if (isPrescribed) {
    eventSubtypeSeverity = 1;
  } else {
    var pct =
      typeof attrs.PercentContained === "number"
        ? attrs.PercentContained
        : null;
    if (pct !== null && pct >= 100) {
      // fully contained WF
      eventSubtypeSeverity = 1;
    } else {
      // active WF
      eventSubtypeSeverity = 3;
    }
  }

  const id =
    attrs.IncidentID ||
    attrs.IRWINID ||
    attrs.globalid ||
    attrs.GlobalID ||
    attrs.OBJECTID;

  return {
    id: String(id || "wildfire-" + headline + "-" + (attrs.POOCounty || "")),
    type: "wildfire",
    source: "esri-wildfires",
    createdAt: new Date().toISOString(),
    eventSubtypeSeverity: eventSubtypeSeverity,
    raw: {
      properties: {
        event: event,
        headline: headline,
        description: description,
        severity: severity,
        POOCounty: attrs.POOCounty,
        POOState: attrs.POOState,
        IncidentTypeCategory: typeCode,
        PercentContained: attrs.PercentContained,
      },
      attributes: attrs,
      geometry: geometry,
    },
  };
}
